export default __webpack_public_path__ + "static/media/juice.43f14fe4.png";